<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">Users</h5>
      </div>
      <div class="trezo-card-subtitle">
        <div class="trezo-card-dropdown relative ltr:-mr-[7px] rtl:-ml-[7px]">
          <button
            type="button"
            class="trezo-card-dropdown-btn inline-block transition-all text-[22px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500"
            :class="{
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: isActive,
            }"
            id="dropdownToggle"
            @click.stop="toggleActive"
          >
            <i class="ri-more-2-fill"></i>
          </button>
          <ul
            class="trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none"
          >
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Day
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Week
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Month
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Year
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="trezo-card-content">
      <ul>
        <li
          class="flex items-center gap-[12px] py-[10px] border-b first:border-t border-primary-50 dark:border-[#172036]"
        >
          <div class="relative ltr:pr-[2px] rtl:pl-[2px] pb-[2px]">
            <img
              src="@/assets/images/users/user60.jpg"
              alt="user-image"
              class="rounded-full w-[33px]"
            />
            <span
              class="absolute ltr:right-0 rtl:left-0 bottom-0 w-[12px] h-[12px] rounded-full bg-success-500 border-[2px] border-white dark:border-[#0c1427]"
            ></span>
          </div>
          <div>
            <span class="block font-semibold text-gray-900 dark:text-gray-400">
              Johhna Loren
            </span>
            <span class="block text-xs mt-[2px]"> Admin </span>
          </div>
        </li>
        <li
          class="flex items-center gap-[12px] py-[10px] border-b first:border-t border-primary-50 dark:border-[#172036]"
        >
          <div class="relative ltr:pr-[2px] rtl:pl-[2px] pb-[2px]">
            <img
              src="@/assets/images/users/user61.jpg"
              alt="user-image"
              class="rounded-full w-[33px]"
            />
            <span
              class="absolute ltr:right-0 rtl:left-0 bottom-0 w-[12px] h-[12px] rounded-full bg-success-500 border-[2px] border-white dark:border-[#0c1427]"
            ></span>
          </div>
          <div>
            <span class="block font-semibold text-gray-900 dark:text-gray-400">
              Zinia Watson Loren
            </span>
            <span class="block text-xs mt-[2px]"> Moderator </span>
          </div>
        </li>
        <li
          class="flex items-center gap-[12px] py-[10px] border-b first:border-t border-primary-50 dark:border-[#172036]"
        >
          <div class="relative ltr:pr-[2px] rtl:pl-[2px] pb-[2px]">
            <img
              src="@/assets/images/users/user62.jpg"
              alt="user-image"
              class="rounded-full w-[33px]"
            />
            <span
              class="absolute ltr:right-0 rtl:left-0 bottom-0 w-[12px] h-[12px] rounded-full bg-success-500 border-[2px] border-white dark:border-[#0c1427]"
            ></span>
          </div>
          <div>
            <span class="block font-semibold text-gray-900 dark:text-gray-400">
              Angela Carter
            </span>
            <span class="block text-xs mt-[2px]"> Editor </span>
          </div>
        </li>
        <li
          class="flex items-center gap-[12px] py-[10px] border-b first:border-t border-primary-50 dark:border-[#172036]"
        >
          <div class="relative ltr:pr-[2px] rtl:pl-[2px] pb-[2px]">
            <img
              src="@/assets/images/users/user63.jpg"
              alt="user-image"
              class="rounded-full w-[33px]"
            />
            <span
              class="absolute ltr:right-0 rtl:left-0 bottom-0 w-[12px] h-[12px] rounded-full bg-gray-400 border-[2px] border-white dark:border-[#0c1427]"
            ></span>
          </div>
          <div>
            <span class="block font-semibold text-gray-900 dark:text-gray-400">
              Skyler White
            </span>
            <span class="block text-xs mt-[2px]"> Admin </span>
          </div>
        </li>
        <li
          class="flex items-center gap-[12px] py-[10px] border-b first:border-t border-primary-50 dark:border-[#172036]"
        >
          <div class="relative ltr:pr-[2px] rtl:pl-[2px] pb-[2px]">
            <img
              src="@/assets/images/users/user64.jpg"
              alt="user-image"
              class="rounded-full w-[33px]"
            />
            <span
              class="absolute ltr:right-0 rtl:left-0 bottom-0 w-[12px] h-[12px] rounded-full bg-success-500 border-[2px] border-white dark:border-[#0c1427]"
            ></span>
          </div>
          <div>
            <span class="block font-semibold text-gray-900 dark:text-gray-400">
              Jane Ronan
            </span>
            <span class="block text-xs mt-[2px]"> Editor </span>
          </div>
        </li>
        <li
          class="flex items-center gap-[12px] py-[10px] border-b first:border-t border-primary-50 dark:border-[#172036]"
        >
          <div class="relative ltr:pr-[2px] rtl:pl-[2px] pb-[2px]">
            <img
              src="@/assets/images/users/user65.jpg"
              alt="user-image"
              class="rounded-full w-[33px]"
            />
            <span
              class="absolute ltr:right-0 rtl:left-0 bottom-0 w-[12px] h-[12px] rounded-full bg-gray-400 border-[2px] border-white dark:border-[#0c1427]"
            ></span>
          </div>
          <div>
            <span class="block font-semibold text-gray-900 dark:text-gray-400">
              Viktor James
            </span>
            <span class="block text-xs mt-[2px]"> Editor </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useClickOutside } from "@/utils/useClickOutside";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Users",
  setup() {
    const { isActive, toggleActive } = useClickOutside("dropdownToggle");

    return {
      isActive,
      toggleActive,
    };
  },
});
</script>
